import { ModalBody, Text } from "@chakra-ui/react";

const ConfirmPopupMessage = ({ children, color }: { children: string; color: string }) => {
  return (
    <ModalBody
      p={" 10px 15px 40px 15px"}
      boxSizing="border-box"
    >
      <Text
        textStyle="body1"
        color={color}
        whiteSpace="pre-line"
      >
        {children}
      </Text>
    </ModalBody>
  );
};

export default ConfirmPopupMessage;
